export default {
    'inputRoot':{
        height: 'max-content'
    }
};
